<template>
  <div id="file">
    <!-- 加载中组件 -->
    <loading-overlay v-if="isLoading"></loading-overlay>
    <!-- <h3>案件详情</h3> -->
    <div class="left" data-html2canvas-ignore="true">
      <el-input
        v-model="name"
        class="search"
        placeholder="请输入查找的文件名称"
        prefix-icon="el-icon-search"
      ></el-input>
      <el-button
        type="warning"
        @click="search"
        style="margin-left: 10px; border-radius: 16px"
        v-if="currentIndex == 0"
        >搜索</el-button
      >
      <!-- 法律文件查询 -->
      <el-button
        type="warning"
        @click="searchLawFile"
        style="margin-left: 10px; border-radius: 16px"
        v-if="currentIndex == 1"
        >搜索</el-button
      >

      <div class="mian">
        <div class="type">
          <div
            class="menu"
            v-for="(item, index) in menu"
            :key="index"
            @click="typeSelect(index)"
            :class="{ active: currentIndex == index }"
          >
            <div class="title">
              <img :src="require('../../assets/' + item.img)" />{{ item.title }}
            </div>
          </div>
        </div>
        <div class="table">
          <el-table
            ref="multipleTable"
            :data="tableData"
            :header-cell-style="{ textAlign: 'center' }"
            :cell-style="{ textAlign: 'center' }"
          >
            <el-table-column prop="name" label="文件名">
              <template slot-scope="scope">
                <span v-if="currentIndex == 0">
                  {{
                    scope.row.name.substring(0, scope.row.name.lastIndexOf('.'))
                  }}
                </span>
                <span v-else>{{ scope.row.name }}</span>
              </template>
            </el-table-column>
            <el-table-column
              prop="fileType"
              label="文件类型"
              v-if="currentIndex == 0"
            >
              <template slot-scope="scope">
                <span v-for="item in fileType" :key="item.value">
                  <span v-if="item.value == scope.row.fileType">
                    {{ item.label }}
                  </span>
                </span>
              </template>
            </el-table-column>
            <el-table-column
              prop="uploadname"
              label="上传人"
              v-if="currentIndex == 0"
            >
            </el-table-column>

            <el-table-column
              prop="date"
              label="上传时间"
              v-if="currentIndex == 0"
            >
              <template slot-scope="scope">
                {{ handleTime(scope.row.date) }}
              </template>
            </el-table-column>
            <el-table-column label="操作">
              <template slot-scope="scope">
                <el-button
                  type="success"
                  size="small"
                  plain
                  style="border-radius: 8px"
                  @click="down(scope.row)"
                  v-if="currentIndex == 0 && downqx"
                  >导出</el-button
                >
                <!-- <el-button
                  type="success"
                  size="small"
                  plain
                  style="border-radius: 8px"
                  @click="exportWord(scope.row)"
                  v-if="currentIndex == 1&&downqx"
                  >导出</el-button
                > -->
                <el-button
                  type="success"
                  size="small"
                  plain
                  style="border-radius: 8px"
                  @click="exportWord(scope.row)"
                  v-if="currentIndex == 1"
                  >{{ daochuOrDayin(scope.row) }}</el-button
                >
                <el-button
                  type="danger"
                  size="small"
                  plain
                  style="border-radius: 8px"
                  v-if="
                    currentIndex == 0 && opentime < handleTime(scope.row.date)
                  "
                  @click="del(scope.row.id)"
                  >删除</el-button
                >
              </template>
            </el-table-column>
          </el-table>
        </div>
      </div>
    </div>
    <!-- <div  data-html2canvas-ignore="true"
      class="right"
      v-if="
        currentIndex == 0 &&
        tableData.length > 0 &&
        tableData[0].casestatus == 0 &&
        tableData[0].caseresult == 0 &&
        fileupdatequanxian &&
        tableData[0].bl
      "
    > -->
    <div
      data-html2canvas-ignore="true"
      class="right"
      v-if="
        currentIndex == 0 &&
        tableDatalength > 0 &&
        tcasestatus == 0 &&
        tcaseresult == 0 &&
        fileupdatequanxian &&
        tbl
      "
    >
      <div style="width: 360px; margin: auto">
        <div style="margin-bottom: 18px">
          上传文件类型：
          <el-select
            v-model="ftype"
            placeholder="请选择文件类型"
            class="select"
          >
            <el-option
              v-for="item in fileType"
              :key="item.value"
              :label="item.label"
              :value="item.value"
              :disabled="item.disabled"
            >
            </el-option>
          </el-select>
        </div>
        <el-upload
          class="upload_file"
          v-model="file"
          drag
          :action="'/api/Filer/CaseUpload?flag=' + Guid + '&filetype=' + ftype"
          multiple
          :on-preview="handlePreview"
          :on-remove="handleRemove"
          :before-upload="beforeUpload"
          :on-success="uploadSuccess"
          :on-change="onChange"
          ref="upload"
        >
          <i class="el-icon-upload"></i>
          <div class="el-upload__text">将文件拖到此处，或<em>点击上传</em></div>
        </el-upload>
      </div>
    </div>
    <!-- 文件类型 -->
    <!-- <el-dialog title="文件类型" center :visible.sync="fileDialog" width="40%">
        <el-select v-model="ftype" placeholder="请选择文件类型" class="select">
                <el-option v-for="item in fileType" :key="item.value" :label="item.label" :value="item.value">
                </el-option>
        </el-select>
        <el-button @click="confirm" type="primary">确认</el-button>
     </el-dialog> -->
    <!-- 选择律所与代理律师 -->
    <el-dialog
      title="选择律所与代理律师"
      center
      :visible.sync="lsDialog"
      width="40%"
      @close="lsClose()"
    >
      <div class="lsdialog">
        <div style="font: 1.8em sans-serif">选择律所&nbsp;</div>
        <el-select
          clearable
          v-model="ls"
          placeholder="请选择"
          @change="lvChange()"
        >
          <el-option
            v-for="item in lvSuo"
            :key="item.value"
            :label="item.label"
            :value="item.label"
          >
          </el-option>
        </el-select>
      </div>
      <div class="lsdialog">
        <div style="font: 1.8em sans-serif">选择律师&nbsp;</div>
        <el-select clearable v-model="lv" placeholder="请选择" multiple>
          <el-option
            v-for="item in lvShi"
            :key="item.sid"
            :label="item.sname"
            :value="item.sname"
          >
          </el-option>
        </el-select>
      </div>
      <div class="printenter">
        <el-button type="primary" @click="printEnter(printData)"
          >确定</el-button
        >
      </div>
    </el-dialog>

    <!-- 代理人选择 -->
    <el-dialog
      title="请选择代理人"
      :visible.sync="clientDialog"
      width="30%"
      center
    >
      <div style="text-align: center">
        <el-select
          v-model="clientOption"
          class="all-select"
          clearable
          placeholder="请选择"
          multiple
        >
          <el-option
            v-for="item in clientOptions"
            :key="item.pcname"
            :label="item.pcname"
            :value="item.pcname"
          />
        </el-select>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button @click="clientDialog = false">取 消</el-button>
        <el-button type="primary" @click="clientPrint(clientOption)"
          >确 认</el-button
        >
      </span>
    </el-dialog>

    <!-- 在线打印 -->
    <div class="dayin" id="dayin" ref="postHtml">
      <div id="casetable">
        <!-- 非诉讼法律业务风险控制 -->
        <div v-if="qrcode == '非诉讼法律业务风险控制'">
          <div class="case_title center_font">
            <span class="CheckTitle">{{ printInfo.printTitle }}</span>
          </div>
          <div class="case_title center_font">非诉讼法律业务风险控制审核表</div>
          <div class="case_main">
            <table class="case_tb" border="1" cellspacing="0" cellpadding="0">
              <tr>
                <td class="td_l" colspan="3">客户/委托人</td>
                <td class="td_r" colspan="7">{{ printInfo.client }}</td>
              </tr>
              <tr>
                <td class="td_l td_gy" colspan="3">委托事务/项目概要</td>
                <td class="td_r" colspan="7">
                  {{ printInfo.cause }}
                </td>
              </tr>
              <tr>
                <td class="td_l" colspan="3">
                  待审文件<br /><span class="td_zhu"
                    >（注：需作为附件提交）</span
                  >
                </td>
                <td class="td_r" colspan="7">
                  {{ printInfo.fileName }}
                </td>
              </tr>
              <tr>
                <td class="td_l td_gy" colspan="3">提交时间</td>
                <td class="td_r" colspan="7">
                  {{ printInfo.postDate }}
                </td>
              </tr>
              <tr>
                <td class="td_l" colspan="3">承办/签字律师意见</td>
                <td class="td_r Lawyer_Names" colspan="7">
                  {{ printInfo.lawyerNames }}
                </td>
              </tr>
              <tr>
                <td class="td_l td_hhr" colspan="3">分管合伙人意见</td>
                <td class="td_r" colspan="7">
                  <!-- @{ //案件对应所有分管合伙人审批项 var fs =
                  db.ApprovalCase_FS.Where(p => p.CaseId == cs.Id && p.Type ==
                  1); var fsstatus = 0; var hhrremark1 =
                  "&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;";
                  var hhrremark2 =
                  "&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;";
                  if (fs.Where(p => p.Status == 3).Count() >= 2) { fsstatus = 7;
                  var jjremark = fs.Where(p => p.Status == 3).OrderBy(p =>
                  p.PostDate).Select(p => p.SysAccount).Take(2).ToList();
                  hhrremark1 = jjremark.FirstOrDefault() == null ? hhrremark1 :
                  jjremark.FirstOrDefault().NikeName +
                  "&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;"; hhrremark2 =
                  jjremark.LastOrDefault() == null ? hhrremark2 :
                  jjremark.LastOrDefault().NikeName +
                  "&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;"; } else if (fs.Where(p
                  => p.Status == 1 || p.Status == 2).Count() >= 2) { fsstatus =
                  5; if (fs.Where(p => p.Status == 1).Count() >= 2) { var
                  ytjremark = fs.Where(p => p.Status == 1).OrderBy(p =>
                  p.PostDate).Select(p => p.SysAccount).Take(2).ToList();
                  hhrremark1 = ytjremark.FirstOrDefault() == null ? hhrremark1 :
                  ytjremark.FirstOrDefault().NikeName +
                  "&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;"; hhrremark2 =
                  ytjremark.LastOrDefault() == null ? hhrremark2 :
                  ytjremark.LastOrDefault().NikeName +
                  "&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;"; } else if (fs.Where(p
                  => p.Status == 2).Count() >= 1) { fsstatus = 6; var ytjremark
                  = fs.Where(p => p.Status == 2).OrderBy(p =>
                  p.PostDate).Select(p => p.SysAccount).ToList(); hhrremark1 =
                  ytjremark.FirstOrDefault() == null ? hhrremark1 :
                  ytjremark.FirstOrDefault().NikeName +
                  "&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;"; if (ytjremark.Count >
                  1) { hhrremark2 = ytjremark.Take(2).LastOrDefault() == null ?
                  hhrremark2 : ytjremark.Take(2).LastOrDefault().NikeName +
                  "&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;"; } } } var hhrlast =
                  fs.OrderByDescending(p => p.PostDate).FirstOrDefault(); } 
                  <label
                    ><input type="checkbox" @(fsstatus == 5 ?
                    "checked=\"checked\"" : "") disabled="disabled" /><span
                      >同意</span
                    ></label
                  >
                  <label
                    ><input type="checkbox" @(fsstatus == 6 ?
                    "checked=\"checked\"" : "") disabled="disabled" /><span
                      >有条件同意</span
                    ></label
                  >
                  <label
                    ><input type="checkbox" @(fsstatus == 7 ?
                    "checked=\"checked\"" : "") disabled="disabled" /><span
                      >不同意</span
                    ></label
                  >
                  <p>
                    <span class="fl">1:</span
                    ><span class="case_span_border">@Html.Raw(hhrremark1)</span>
                  </p>
                  <p>
                    <span class="fl">2:</span
                    ><span class="case_span_border">@Html.Raw(hhrremark2)</span
                    ><span class="td_p_date"
                      >@Html.Raw((hhrlast == null || hhrlast.PostDate == null) ?
                      " 年 月 日" :
                      Helper.TypeHelper.ToDateTime(hhrlast.PostDate).ToString("yyyy年MM月dd日"))</span
                    >
                  </p>-->
                </td>
              </tr>
              <tr>
                <td class="td_l" colspan="3">
                  提交风控委审核<br /><span class="td_zhu"
                    >（注：如有2名合伙人签字同意则无需提交风控委审核）</span
                  >
                </td>
                <td class="td_r" colspan="7">
                  <!-- <label
                    ><input type="checkbox" @((fsstatus == 7 || fsstatus == 0) ?
                    "checked=\"checked\"" : "") disabled="disabled" /><span
                      >是</span
                    ></label
                  >
                  <label
                    ><input type="checkbox" @((fsstatus == 5 || fsstatus == 6) ?
                    "checked=\"checked\"" : "") disabled="disabled" /><span
                      >否</span
                    ></label
                  > -->
                </td>
              </tr>

              <tr>
                <td class="td_l" colspan="3">
                  风控委员意见<br /><span class="td_zhu"
                    >（注：至少需2名委员同意）</span
                  >
                </td>
                <td class="td_r" colspan="7">
                  <!-- @{ //案件对应所有风控委员审批项 var fsfx =
                  db.ApprovalCase_FS.Where(p => p.CaseId == cs.Id && p.Type ==
                  2); var fxremark1 =
                  "&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;";
                  var fxremark2 =
                  "&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;";
                  if (fsstatus == 7 || fsstatus == 0) { if (fsfx.Where(p =>
                  p.Status == 3).Count() >= 2) { var jjremark = fsfx.Where(p =>
                  p.Status == 3).OrderBy(p => p.PostDate).Select(p =>
                  p.SysAccount).Take(2).ToList(); fxremark1 =
                  jjremark.FirstOrDefault() == null ? fxremark1 :
                  jjremark.FirstOrDefault().NikeName +
                  "&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;"; fxremark2 =
                  jjremark.LastOrDefault() == null ? fxremark2 :
                  jjremark.LastOrDefault().NikeName +
                  "&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;"; } else if
                  (fsfx.Where(p => p.Status == 1 || p.Status == 2).Count() >= 2)
                  { if (fsfx.Where(p => p.Status == 1).Count() >= 2) { var
                  ytjremark = fsfx.Where(p => p.Status == 1).OrderBy(p =>
                  p.PostDate).Select(p => p.SysAccount).Take(2).ToList();
                  fxremark1 = ytjremark.FirstOrDefault() == null ? fxremark1 :
                  ytjremark.FirstOrDefault().NikeName +
                  "&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;"; fxremark2 =
                  ytjremark.LastOrDefault() == null ? fxremark2 :
                  ytjremark.LastOrDefault().NikeName +
                  "&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;"; } else if
                  (fsfx.Where(p => p.Status == 2).Count() >= 1) { var ytjremark
                  = fsfx.Where(p => p.Status == 2).OrderBy(p =>
                  p.PostDate).Select(p => p.SysAccount).ToList(); fxremark1 =
                  ytjremark.FirstOrDefault() == null ? fxremark1 :
                  ytjremark.FirstOrDefault().NikeName +
                  "&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;"; if (ytjremark.Count >
                  1) { fxremark2 = ytjremark.Take(2).LastOrDefault() == null ?
                  fxremark2 : ytjremark.Take(2).LastOrDefault().NikeName +
                  "&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;"; } } } } var fxlast =
                  fsfx.OrderByDescending(p => p.PostDate).FirstOrDefault(); }
                  <label
                    ><input type="checkbox" @((fsstatus == 7 || fsstatus == 0) ?
                    (cs.Status == 5 ? "checked=\"checked\"" : "") : "")
                    disabled="disabled" /><span>同意</span></label
                  >
                  <label
                    ><input type="checkbox" @((fsstatus == 7 || fsstatus == 0) ?
                    (cs.Status == 6 ? "checked=\"checked\"" : "") : "")
                    disabled="disabled" /><span>有条件同意</span></label
                  >
                  <label
                    ><input type="checkbox" @((fsstatus == 7 || fsstatus == 0) ?
                    (cs.Status == 7 ? "checked=\"checked\"" : "") : "")
                    disabled="disabled" /><span>不同意</span></label
                  >
                  <p>
                    <span class="fl">1:</span
                    ><span class="case_span_border">@Html.Raw(fxremark1)</span>
                  </p>
                  <p>
                    <span class="fl">2:</span
                    ><span class="case_span_border">@Html.Raw(fxremark2)</span>
                  </p> -->
                </td>
              </tr>
              <tr>
                <td class="td_l" colspan="3">审核时间</td>
                <td class="td_r" colspan="7">
                  {{ printInfo.checkDate }}
                </td>
              </tr>
            </table>
            <div class="case_row"></div>
          </div>
        </div>

        <!-- 法律意见书审批单 -->
        <div v-if="qrcode == '法律意见书审批单'">
          <div class="case_title center_font">
            <span class="CheckTitle">{{ printInfo.printTitle }}</span>
          </div>
          <div class="case_title center_font">非诉讼法律业务风险控制审核表</div>
          <div class="case_main">
            <table class="case_tb" border="1" cellspacing="0" cellpadding="0">
              <tr>
                <td class="td_l" colspan="3">客户/委托人</td>
                <td class="td_r" colspan="7">{{ printInfo.client }}</td>
              </tr>
              <tr>
                <td class="td_l td_gy" colspan="3">委托事务/项目概要</td>
                <td class="td_r" colspan="7">
                  {{ printInfo.cause }}
                </td>
              </tr>
              <tr>
                <td class="td_l" colspan="3">用章类型</td>
                <td class="td_r" colspan="7">{{ printInfo.sealType }}</td>
              </tr>
              <tr>
                <td class="td_l" colspan="3">
                  待审文件<br /><span class="td_zhu"
                    >（注：需作为附件提交）</span
                  >
                </td>
                <td class="td_r" colspan="7">
                  {{ printInfo.fileName }}
                </td>
              </tr>
              <tr>
                <td class="td_l td_gy" colspan="3">提交时间</td>
                <td class="td_r" colspan="7">
                  {{ printInfo.postDate }}
                </td>
              </tr>
              <tr>
                <td class="td_l" colspan="3">承办/签字律师意见</td>
                <td class="td_r Lawyer_Names" colspan="7">
                  {{ printInfo.lawyerNames }}
                </td>
              </tr>
              <tr>
                <td class="td_l td_hhr" colspan="3">分管合伙人意见</td>
                <td class="td_r" colspan="7">
                  <label
                    ><input
                      type="checkbox"
                      :checked="
                        printInfo.fkwResult1 == true ||
                        printInfo.fkwResult2 == true
                      "
                    /><span>同意</span></label
                  >
                  <label
                    ><input
                      type="checkbox"
                      :checked="
                        printInfo.fkwRemark1 != null ||
                        printInfo.fkwRemark1 != null
                      "
                    /><span>有条件同意</span></label
                  >
                  <label
                    ><input
                      type="checkbox"
                      :checked="
                        printInfo.fkwResult1 == false ||
                        printInfo.fkwResult2 == false
                      "
                    /><span>不同意</span></label
                  >
                  <p>
                    <span class="fl">1:</span
                    ><span class="case_span_border">{{ printInfo.fkw1 }}</span>
                  </p>
                  <p>
                    <span class="fl">2:</span
                    ><span class="case_span_border">{{ printInfo.fkw2 }}</span>
                  </p>
                </td>
              </tr>
              <!-- <tr>
                <td class="td_l" colspan="3">
                  提交风控委审核<br /><span class="td_zhu"
                    >（注：如有2名合伙人签字同意则无需提交风控委审核）</span
                  >
                </td>
                <td class="td_r" colspan="7">
                  <label
                    ><input type="checkbox" :checked="true" /><span
                      >是</span
                    ></label
                  >·
                  <label
                    ><input type="checkbox" :checked="true" /><span
                      >否</span
                    ></label
                  >
                </td>
              </tr>

              <tr>
                <td class="td_l" colspan="3">
                  风控委员意见<br /><span class="td_zhu"
                    >（注：至少需2名委员同意）</span
                  >
                </td>
                <td class="td_r" colspan="7">
                  <label
                    ><input type="checkbox" :checked="true" /><span
                      >同意</span
                    ></label
                  >
                  <label
                    ><input type="checkbox" :checked="true" /><span
                      >有条件同意</span
                    ></label
                  >
                  <label
                    ><input type="checkbox" :checked="true" /><span
                      >不同意</span
                    ></label
                  >
                  <p>
                    <span class="fl">1:</span
                    ><span class="case_span_border">{{ printInfo.fkw1 }}</span>
                  </p>
                  <p>
                    <span class="fl">2:</span
                    ><span class="case_span_border">{{ printInfo.fkw2 }}</span>
                  </p>
                </td>
              </tr> -->
              <tr>
                <td class="td_l" colspan="3">审核时间</td>
                <td class="td_r" colspan="7">
                  {{ printInfo.checkDate }}
                </td>
              </tr>
            </table>
            <div class="case_row"></div>
          </div>
        </div>

        <!-- 单独出具律师函审批单 -->
        <div v-if="qrcode == '单独出具律师函审批单'">
          <div class="case_title center_font">
            <span class="CheckTitle">{{ printInfo.printTitle }}</span>
          </div>
          <div class="case_title center_font">单独出具律师函审批单</div>
          <div class="case_main">
            <table
              class="case_tb"
              border="1"
              cellspacing="0"
              cellpadding="0"
              style="height: 600px"
            >
              <tr>
                <td class="td_l" colspan="3">项目名称</td>
                <td class="td_r" colspan="7">{{ printInfo.title }}</td>
              </tr>
              <tr>
                <td class="td_l td_gy" colspan="3">项目概要</td>
                <td class="td_r td_gaiyao" colspan="7">
                  {{ printInfo.cause }}
                </td>
              </tr>
              <tr>
                <td class="td_l td_gy" colspan="3">提交时间</td>
                <td class="td_r" colspan="7">
                  {{ printInfo.postDate }}
                </td>
              </tr>
              <tr>
                <td class="td_l" colspan="3">承办/签字律师</td>
                <td class="td_r Lawyer_Names" colspan="7">
                  {{ printInfo.lawyerNames }}
                </td>
              </tr>
              <tr>
                <td class="td_l td_hhr" colspan="3">收费情况</td>
                <td class="td_r" colspan="7">
                  <label style="width: 100%; text-align: center">{{
                    printInfo.charge
                  }}</label
                  ><br />
                </td>
              </tr>
              <tr>
                <td class="td_l" colspan="3">部长意见</td>
                <td class="td_r" colspan="7">
                  <!-- @{ var approval = db.ApprovalCase.Where(p => p.CaseId ==
                  caseid).OrderByDescending(p => p.Postdate).FirstOrDefault();
                  var buzhangname = approval == null ? "" : approval.SysAccount
                  == null ? "" : approval.SysAccount.NikeName; buzhangname +=
                  "&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;";
                  }
                  <label
                    ><input type="checkbox" @(cs.Status == 1 ?
                    "checked=\"checked\"" : "") disabled="disabled" /><span
                      >同意</span
                    ></label
                  >
                  <label
                    ><input type="checkbox" @(cs.Status == 2 ?
                    "checked=\"checked\"" : "") disabled="disabled" /><span
                      >不同意</span
                    ></label
                  >
                  <p>
                    <span class="fl">1:</span
                    ><span class="case_span_border"
                      >@Html.Raw(buzhangname)</span
                    >
                  </p>
                  <p>
                    <span class="td_p_date"
                      >@Html.Raw((approval == null || approval.Postdate == null)
                      ? " 年 月 日" :
                      Helper.TypeHelper.ToDateTime(approval.Postdate).ToString("yyyy年MM月dd日"))</span
                    >
                  </p> -->
                </td>
              </tr>
              <tr>
                <td class="td_l" colspan="3">审核时间</td>
                <td class="td_r" colspan="7">
                  {{ printInfo.checkDate }}
                </td>
              </tr>
            </table>
            <div class="case_row"></div>
          </div>
        </div>

        <!-- 律师出庭函 -->
        <div v-if="qrcode == '律师出庭函'">
          <div class="case_row"></div>
          <div class="case_title center_font">
            <span class="CheckTitle">{{ printInfo.printTitle }}函</span
            ><span style="font-size: 18.6px">（律师出庭函）</span>
          </div>
          <div class="case_code center_font text-right">
            {{ printInfo.caseCode }}
          </div>

          <div class="case_row"></div>

          <div class="case_main">
            <div class="case_row"></div>
            <div>
              <p class="text_space">
                贵院受理<span class="case_span_border">
                  {{ printInfo.yuanGao }} </span
                >与<span class="case_span_border">
                  {{ printInfo.beiGao }} {{ printInfo.diSanren }}
                  {{ printInfo.ysBeigao }}</span
                ><span class="case_span_border">{{ printInfo.cause }} </span
                >一案， 本所接受当事人委托，指派<span
                  class="case_span_border Lawyer_Names"
                >
                  {{ printInfo.lawyerNames }} </span
                >律师为
                <span class="case_span_border"> {{ printInfo.client }} </span
                >的代理人。
              </p>
            </div>
            <div class="text_space">特此函告</div>
            <div class="text_space">此致</div>
            <!-- "han_margintop" : "minwidth" -->
            <div>
              <p>
                <span class="case_span_border minwidth">
                  {{ printInfo.acceptUnit }}
                </span>
              </p>
            </div>
            <div style="height: 200px; position: relative">
              <p style="position: absolute; right: 0; bottom: 30px">
                <span class="CheckTitle">{{ printInfo.printTitle }}</span>
              </p>
              <p style="position: absolute; right: 0; bottom: 0">
                &nbsp; 年 &nbsp; 月 &nbsp; 日
              </p>
            </div>
            <div class="case_row"></div>
          </div>
        </div>

        <!-- 行政复议出庭函 -->
        <div v-if="qrcode == '行政复议出庭函'">
          <div class="case_row"></div>
          <div class="case_title center_font">
            <span class="CheckTitle">{{ printInfo.printTitle }}</span
            ><span style="font-size: 18.6px">（律师出庭函）</span>
          </div>
          <div class="case_code center_font text-right">
            {{ printInfo.caseCode }}
          </div>
          <div class="case_main">
            <div>
              <p class="text_space">
                贵院/委受理<span class="case_span_border">
                  {{ printInfo.yuanGao }} </span
                >诉<span class="case_span_border">
                  {{ printInfo.beiGao }} {{ printInfo.diSanren }}
                  {{ printInfo.ysBeigao }} </span
                >因<span class="case_span_border"> {{ printInfo.cause }} </span
                >一案， 本所接受当事人委托，指派<span
                  class="case_span_border Lawyer_Names"
                >
                  {{ printInfo.lawyerNames }} </span
                >律师为
                <span class="case_span_border"> {{ printInfo.client }} </span
                >的复议代理人。
              </p>
            </div>
            <div class="text_space">特此函告</div>
            <div class="text_space">此致</div>
            <div>
              <p>
                <span class="case_span_border minwidth">
                  {{ printInfo.acceptUnit }}
                </span>
              </p>
            </div>
            <div style="height: 200px; position: relative">
              <p style="position: absolute; right: 0; bottom: 30px">
                <span class="CheckTitle">{{ printInfo.printTitle }}</span>
              </p>
              <p style="position: absolute; right: 0; bottom: 0">
                &nbsp; 年 &nbsp; 月 &nbsp; 日
              </p>
            </div>

            <div class="case_row"></div>
          </div>
        </div>

        <!-- 听证出庭函 -->
        <div v-if="qrcode == '听证出庭函'">
          <div class="case_row"></div>
          <div class="case_title center_font">
            <span class="CheckTitle">{{ printInfo.printTitle }}</span
            ><span style="font-size: 18.6px">（律师出庭函）</span>
          </div>
          <div class="case_code center_font text-right">
            {{ printInfo.caseCode }}
          </div>
          <div class="case_main">
            <div>
              <p class="text_space">
                贵院受理<span class="case_span_border">
                  {{ printInfo.yuanGao }} </span
                >诉<span class="case_span_border">
                  {{ printInfo.beiGao }} {{ printInfo.diSanren }}
                  {{ printInfo.ysBeigao }}</span
                ><span class="case_span_border"> {{ printInfo.cause }} </span
                >申请再听证一案， 本所接受当事人委托，指派<span
                  class="case_span_border Lawyer_Names"
                >
                  {{ printInfo.lawyerNames }} </span
                >律师为
                <span class="case_span_border"> {{ printInfo.client }} </span
                >的复议代理人。
              </p>
            </div>
            <div class="text_space">特此函告</div>
            <div class="text_space">此致</div>
            <div>
              <p>
                <span class="case_span_border minwidth">
                  {{ printInfo.acceptUnit }}
                </span>
              </p>
            </div>
            <div style="height: 200px; position: relative">
              <p style="position: absolute; right: 0; bottom: 30px">
                <span class="CheckTitle">{{ printInfo.printTitle }}</span>
              </p>
              <p style="position: absolute; right: 0; bottom: 0">
                &nbsp; 年 &nbsp; 月 &nbsp; 日
              </p>
            </div>

            <div class="case_row"></div>
          </div>
        </div>

        <!-- 律师出庭函
        <div v-if="qrcode == '律师出庭函'">
          <div class="case_row"></div>
          <div class="case_title center_font">
            <span class="CheckTitle">{{ printInfo.printTitle }}</span
            >函<span style="font-size: 18.6px">（律师出庭函）</span>
          </div>
          <div class="case_code center_font text-right">
            {{ printInfo.caseCode }}
          </div>
          <div class="case_row"></div>
          <div class="case_main">
            <div class="case_row"></div>
            <div>
              <p class="text_space">
                贵委受理<span class="case_span_border">
                  {{ printInfo.yuanGao }} </span
                >与<span class="case_span_border">
                  {{ printInfo.beiGao }} {{ printInfo.diSanren }}</span
                ><span class="case_span_border">{{ printInfo.cause }} </span
                >一案， 本所接受当事人委托，指派<span
                  class="case_span_borde Lawyer_Namesr"
                >
                  {{ printInfo.lawyerNames }} </span
                >律师为
                <span class="case_span_border"> {{ printInfo.client }} </span
                >的代理人。
              </p>
            </div>
            <div class="text_space">特此函告</div>
            <div class="text_space">此致</div>
            <div>
              <p>
                <span class="case_span_border minwidth">
                  {{ printInfo.acceptUnit }}
                </span>
              </p>
            </div>
            <div style="height: 200px; position: relative">
              <p style="position: absolute; right: 0; bottom: 30px">
                <span class="CheckTitle">{{ printInfo.printTitle }}</span>
              </p>
              <p style="position: absolute; right: 0; bottom: 0">
                &nbsp; 年 &nbsp; 月 &nbsp; 日
              </p>
            </div>
            <div class="case_row"></div>

            <div>
              <div class="qrcodefalvzc" style="display: none"></div>
              <img id="qrcodefalvzc" alt="律师出庭函二维码" class="qrcode" />
              <p>显示案件基本信息</p>
            </div>
          </div>
        </div> -->

        <!-- 律师事务所函（侦查） -->
        <div
          style="margin-bottom: 40px"
          v-if="qrcode == '律师事务所函（侦查）'"
        >
          <div class="case_row"></div>
          <div class="case_title center_font">
            <span class="CheckTitle">{{ printInfo.printTitle }}</span
            >函
          </div>
          <div class="case_code center_font">{{ printInfo.caseCode }}</div>
          <div class="case_row"></div>
          <div class="case_main">
            <p class="chenghu">
              <span class="case_span_border minwidth">
                {{ printInfo.acceptUnit }}</span
              ><span>:</span>
            </p>
            <div class="case_row"></div>
            <div>
              <p class="text_space">
                本所接受<span class="case_span_border">
                  {{ printInfo.client }} </span
                >的委托，指派<span class="case_span_border Lawyer_Names">
                  {{ printInfo.lawyerNames }}
                </span>
                律师担任
                <span class="case_span_border">
                  {{ printInfo.printTitle }} </span
                >案件<span class="case_span_border">
                  {{ printInfo.client }} </span
                >的律师。
              </p>
            </div>
            <div class="text_space">特此函告</div>
            <div style="height: 200px; position: relative">
              <p style="position: absolute; right: 0; bottom: 30px">
                （律师事务所章）
              </p>
              <p style="position: absolute; right: 0; bottom: 0">
                &nbsp; 年 &nbsp; 月 &nbsp; 日
              </p>
            </div>
            <p>附：授权委托书一份</p>
          </div>
        </div>
        <p style="position: absolute; bottom: 0">{{ printInfo.address }}</p>

        <!-- 律师会见在押犯罪嫌疑人的函（侦查） -->
        <div
          style="margin-bottom: 40px"
          v-if="qrcode == '律师会见在押犯罪嫌疑人的函（侦查）'"
        >
          <div>
            <div class="case_row"></div>
            <div class="case_title center_font">律师会见在押犯罪嫌疑人的函</div>
            <div class="case_code center_font">{{ printInfo.caseCode }}</div>
            <div class="case_row"></div>
            <div class="case_main">
              <p>
                <span class="case_span_border minwidth">
                  {{ printInfo.acceptUnit }} </span
                ><span>:</span>
              </p>
              <div class="case_row"></div>
              <div>
                <p class="text_space">
                  根据《中华人民共和国刑事诉讼法》第九十六条以及《中华人民共和国律师法》第三十条的规定，
                  我所<span class="case_span_border Lawyer_Names">
                    {{ printInfo.lawyerNames }} </span
                  >律师拟前往<span class="case_span_border">
                    &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; </span
                  >会见<span class="case_span_border">
                    {{ printInfo.title }} </span
                  >案的在押犯罪嫌疑人<span class="case_span_border">
                    {{ printInfo.beiGao }} </span
                  >。
                </p>
                <p>
                  时间：<span class="input_shortcon"></span>年<span
                    class="input_shortcon"
                  ></span
                  >月<span class="input_shortcon"></span>日<span
                    class="input_shortcon"
                  ></span
                  >时，请予安排。
                </p>
              </div>
              <div class="case_row"></div>
              <div class="text_space">特此函告</div>
              <div style="height: 200px; position: relative">
                <p style="position: absolute; right: 0; bottom: 30px">
                  （律师事务所章）
                </p>
                <p style="position: absolute; right: 0; bottom: 0">
                  &nbsp; 年 &nbsp; 月 &nbsp; 日
                </p>
              </div>
            </div>
          </div>
        </div>

        <!-- 律师事务所函（检、审） -->
        <div v-if="qrcode == '律师事务所函（检、审）'">
          <div class="case_row"></div>
          <div class="case_title center_font">
            <span class="CheckTitle">{{ printInfo.printTitle }}</span
            >函
          </div>
          <div class="case_code center_font">{{ printInfo.caseCode }}</div>
          <div class="case_row"></div>
          <div class="case_main">
            <p class="chenghu">
              <span class="case_span_border minwidth">
                {{ printInfo.acceptUnit }} </span
              ><span>:</span>
            </p>
            <div class="case_row"></div>
            <div>
              <p class="text_space">
                本所接受<span class="case_span_border">
                  {{ printInfo.client }}
                </span>
                的委托，指派<span class="case_span_border Lawyer_Names">
                  {{ printInfo.lawyerNames }} </span
                >律师担任你院办理的
                <span class="case_span_border"> {{ printInfo.title }} </span
                >案件<span class="case_span_border">
                  {{ printInfo.client }} </span
                >的辩护人。
              </p>
            </div>
            <div class="text_space">特此函告</div>
            <div style="height: 200px; position: relative">
              <p style="position: absolute; right: 0; bottom: 30px">
                （律师事务所章）
              </p>
              <p style="position: absolute; right: 0; bottom: 0">
                &nbsp; 年 &nbsp; 月 &nbsp; 日
              </p>
            </div>
            <p>附：授权委托书一份</p>
            <div class="case_row"></div>
          </div>
        </div>

        <!-- 律师事务所函（刑诉代理人） -->
        <div v-if="qrcode == '律师事务所函（刑诉代理人）'">
          <div class="case_row"></div>
          <div class="case_title center_font">
            <span class="CheckTitle">{{ printInfo.printTitle }}</span
            >函
          </div>
          <div class="case_code center_font">{{ printInfo.caseCode }}</div>
          <div class="case_row"></div>
          <div class="case_main">
            <p>
              <span class="case_span_border minwidth">
                {{ printInfo.acceptUnit }}</span
              ><span>:</span>
            </p>
            <div class="case_row"></div>
            <div>
              <p class="text_space">
                本所接受<span class="case_span_border">
                  {{ printInfo.client }}
                </span>
                委托，指派<span class="case_span_border Lawyer_Names">
                  {{ printInfo.lawyerNames }}
                </span>
                律师担任你院办理的<span class="case_span_border">
                  {{ printInfo.title }} </span
                >案件<span class="case_span_border">
                  {{ printInfo.client }} </span
                >的诉讼代理人。
              </p>
            </div>
            <div class="text_space">特此函告</div>
            <div style="height: 200px; position: relative">
              <p style="position: absolute; right: 0; bottom: 30px">
                （律师事务所章）
              </p>
              <p style="position: absolute; right: 0; bottom: 0">
                &nbsp; 年 &nbsp; 月 &nbsp; 日
              </p>
            </div>
            <p>附：授权委托书一份</p>
            <div class="case_row"></div>
          </div>
        </div>

        <!-- 指定辩护函 -->
        <div v-if="qrcode == '指定辩护函'">
          <div class="case_row"></div>
          <div class="case_title center_font">指定辩护函</div>
          <div class="case_code center_font">{{ printInfo.caseCode }}</div>
          <div class="case_row"></div>
          <div class="case_main">
            <p>
              <span class="case_span_border minwidth">
                {{ printInfo.acceptUnit }}
              </span>
            </p>
            <div class="case_row"></div>
            <div>
              <p class="text_space">
                根据《中华人民共和国刑事诉讼法》第三十四条的规定及贵院的来函，本所指派<span
                  class="case_span_border Lawyer_Names"
                >
                  {{ printInfo.lawyerNames }} </span
                >律师担任
                <span class="case_span_border"> {{ printInfo.title }} </span
                >案件<span class="case_span_border">
                  {{ printInfo.client }} </span
                >的辩护人。
              </p>
            </div>
            <div class="text_space">特此函告</div>
            <div style="height: 200px; position: relative">
              <p style="position: absolute; right: 0; bottom: 30px">
                （律师事务所章）
              </p>
              <p style="position: absolute; right: 0; bottom: 0">
                &nbsp; 年 &nbsp; 月 &nbsp; 日
              </p>
            </div>
            <div class="case_row"></div>
          </div>
        </div>

        <!-- 案件审批单 -->
        <div v-if="qrcode == '案件审批单'">
          <div class="case_title center_font" style="line-height: 30px">
            <span class="CheckTitle">{{ printInfo.printTitle }}</span>
          </div>
          <div
            class="case_title center_font"
            style="line-height: 30px; margin-bottom: 15px"
          >
            案件审批单
          </div>

          <div class="case_main">
            <table class="case_tb" border="1" cellspacing="0" cellpadding="0">
              <tr>
                <td class="td_l" colspan="3">案件名称</td>
                <td class="td_r" colspan="7" style="text-align: center">
                  {{ printInfo.title }}
                </td>
              </tr>
              <tr>
                <td class="td_l" colspan="3">案件编号</td>
                <td class="td_r" colspan="7" style="text-align: center">
                  {{ printInfo.caseCode }}
                </td>
              </tr>
              <tr>
                <td class="td_l" colspan="3">案件类型</td>
                <td class="td_r Lawyer_Names" colspan="7">
                  {{ printInfo.caseType }}
                </td>
              </tr>
              <tr>
                <td class="td_l" colspan="3">案件用章类型</td>
                <td class="td_r Lawyer_Names" colspan="7">
                  {{ printInfo.sealType }}
                </td>
              </tr>
              <tr>
                <td class="td_l" colspan="3">代理律师</td>
                <td class="td_r Lawyer_Names" colspan="7">
                  {{ printInfo.lawyerNames }}
                </td>
              </tr>
              <tr>
                <td class="td_l" colspan="3">提交时间</td>
                <td class="td_r Lawyer_Names" colspan="7">
                  {{ printInfo.postDate }}
                </td>
              </tr>
              <tr>
                <td class="td_l" colspan="3">审批情况</td>
                <td class="td_r Lawyer_Names" colspan="7">
                  {{ printInfo.shr }}
                </td>
              </tr>

              <tr>
                <td class="td_l" colspan="3">部门盖章</td>
                <td class="td_r Lawyer_Names" colspan="7"></td>
              </tr>
            </table>
          </div>
          <div class="case_row"></div>
        </div>

        <!-- 二维码 -->
        <!-- <div class="code">
              <img :src="img" />
          </div> -->
        <div id="ercode" data-html2canvas-ignore="true"></div>
      </div>
    </div>
    <!-- <img :src="imhurl" style="width: 100%; height: 600px"> -->
  </div>
</template>
      
<script>
import { BidFile, BankruptFile, FileDel, BidDetail } from '../../api/bankrupt'
import { requestDownLoadFile, requestReview } from '../../api/seal'
import {
  filesPrintLvSuoApi,
  filesPrintInfoApi,
  getNewSealType
} from '../../api/case'
import PizZip from 'pizzip'
import docxtemplater from 'docxtemplater'
import JSZipUtils from 'jszip-utils'
import { saveAs } from 'file-saver'
import printJS from 'print-js'
import html2canvas from 'html2canvas'
import QRCode from 'qrcodejs2'
import axios from 'axios'
// 定义blob对应的type
const fileTypeMap = {
  xls: 'application/vnd.ms-excel',
  xlsx: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
  doc: 'application/msword',
  docx: 'application/vnd.openxmlformats-officedocument.wordprocessingml.document',
  pdf: 'application/pdf',
  ppt: 'application/pdf',
  pptx: 'application/vnd.openxmlformats-officedocument.presentationml.presentation',
  png: 'image/png',
  gif: 'image/gif',
  jpeg: 'image/jpeg',
  jpg: 'image/jpeg',
  txt: 'text/plain'
}
export default {
  name: 'bankruptdetail',
  // components:{
  //   Table
  // },
  data() {
    return {
      isLoading: false,
      img: '',
      downqx: false, //导出权限
      fileupdatequanxian: false, //附件更新权限
      next: true, //三级页面
      casetype: '', //案件类型
      filetype: '案件附件', //附件类型
      Guid: '', //案件uid,
      CaseStatus: 1,
      menu: [
        {
          title: '案件附件',
          img: 'file.jpg'
        },
        {
          title: '法律文件',
          img: 'file.jpg'
        }
      ],
      opentime: null, //打开页面时间
      name: '', //要查找的文件名称
      currentIndex: 0, //默认选择
      tableData: [],
      file: [], //上传附件
      ftype: '',
      fileType: [], //文件类型
      ftype: '招标',
      fileDialog: false,
      // fileupload:false,//是否确定上传文件
      FileTime: null, //进入页面的时间

      // ygr
      form: {},
      //图片
      img1: '',
      img2: '',
      falvTable: [
        // {
        //   name: '委托协议（辩护）', // 模板名
        //   type: 1 // 类型(1:导出，2:打印)
        // },
        // {
        //   name: '为犯罪嫌疑人提供帮助的委托协议', // 模板名
        //   type: 1 // 类型(1:导出，2:打印)
        // },
        // {
        //   name: '授权委托书（侦查）', // 模板名
        //   type: 1 // 类型(1:导出，2:打印)
        // },
        // {
        //   name: '授权委托书（检、审）', // 模板名
        //   type: 1 // 类型(1:导出，2:打印)
        // },
        // {
        //   name: '会见专用介绍信（嫌疑人 被告人）', // 模板名
        //   type: 1 // 类型(1:导出，2:打印)
        // },
        // {
        //   name: '取保候审申请书', // 模板名
        //   type: 1 // 类型(1:导出，2:打印)
        // },
        // {
        //   name: '刑事案件代理委托协议（诉讼代理人）', // 模板名
        //   type: 1 // 类型(1:导出，2:打印)
        // },
        // {
        //   name: '授权委托书（刑事附带民事）', // 模板名
        //   type: 1 // 类型(1:导出，2:打印)
        // },
        // {
        //   name: '授权委托书（诉讼代表人）', // 模板名
        //   type: 1 // 类型(1:导出，2:打印)
        // },
        // {
        //   name: '调查取证申请书', // 模板名
        //   type: 1 // 类型(1:导出，2:打印)
        // },
        // {
        //   name: '延期审理申请书', // 模板名
        //   type: 1 // 类型(1:导出，2:打印)
        // },
        // {
        //   name: '解除强制措施申请书', // 模板名
        //   type: 1 // 类型(1:导出，2:打印)
        // },
        // {
        //   name: '提请收集、调取证据申请书', // 模板名
        //   type: 1 // 类型(1:导出，2:打印)
        // },
        // {
        //   name: '通知证人出庭申请书', // 模板名
        //   type: 1 // 类型(1:导出，2:打印)
        // },
        // {
        //   name: '申请取保候审保证书', // 模板名
        //   type: 1 // 类型(1:导出，2:打印)
        // },
        // {
        //   name: '会见在押犯罪嫌疑人申请书（涉及国密）', // 模板名
        //   type: 1 // 类型(1:导出，2:打印)
        // },
        // {
        //   name: '重新鉴定、勘验申请书', // 模板名
        //   type: 1 // 类型(1:导出，2:打印)
        // },
        // {
        //   name: '授权委托书(单位)', // 模板名
        //   type: 1 // 类型(1:导出，2:打印)
        // },
        // {
        //   name: '授权委托书(个人)', // 模板名
        //   type: 1 // 类型(1:导出，2:打印)
        // },
        // {
        //   name: '执行授权委托书(单位)', // 模板名
        //   type: 1 // 类型(1:导出，2:打印)
        // },
        // {
        //   name: '执行授权委托书(个人)', // 模板名
        //   type: 1 // 类型(1:导出，2:打印)
        // },
        // {
        //   name: '法律意见书审批单', // 模板名
        //   type: 1 // 类型(1:导出，2:打印)
        // },
        // {
        //   name: '新天伦律师事务所用印审批', // 模板名
        //   type: 1 // 类型(1:导出，2:打印)
        // },
        // //----------------------------------------------------
        // {
        //   name: '律师事务所函（侦查）', // 模板名
        //   type: 2 // 类型(1:导出，2:打印)
        // },
        // {
        //   name: '律师会见在押犯罪嫌疑人的函（侦查）', // 模板名
        //   type: 2 // 类型(1:导出，2:打印)
        // },
        // {
        //   name: '律师事务所函（检、审）', // 模板名
        //   type: 2 // 类型(1:导出，2:打印)
        // },
        // {
        //   name: '律师事务所函（刑诉代理人）', // 模板名
        //   type: 2 // 类型(1:导出，2:打印)
        // },
        // {
        //   name: '指定辩护函', // 模板名
        //   type: 2 // 类型(1:导出，2:打印)
        // },
        // {
        //   name: '律师出庭函', // 模板名
        //   type: 2 // 类型(1:导出，2:打印)
        // },
        // {
        //   name: '非诉讼法律业务风险控制', // 模板名
        //   type: 2 // 类型(1:导出，2:打印)
        // },
        // {
        //   name: '单独出具律师函审批单', // 模板名
        //   type: 2 // 类型(1:导出，2:打印)
        // },
        // {
        //   name: '行政复议出庭函', // 模板名
        //   type: 2 // 类型(1:导出，2:打印)
        // },
        // {
        //   name: '听证出庭函', // 模板名
        //   type: 2 // 类型(1:导出，2:打印)
        // },
        // {
        //   name: '案件审批单', // 模板名
        //   type: 2 // 类型(1:导出，2:打印)
        // }
      ],

      bclName: '', // 被代理人
      yuanGao: '', //原告
      beiGao: '', //被告
      diSanRen: '', // 第三人
      agentOther: '', // 非被代理人
      nullxl: [
        {
          xlName: '姓名',
          xlUnit: '工作单位',
          xlTel: '电话',
          xlDuties: '职务'
        }
      ],
      xl: [],
      imhurl: null,
      // 打印
      lsDialog: false, // 选择律所
      lvSuo: [], // 返回的律所
      lvShi: [], // 返回的代理律师
      ls: null, // 选的律所
      lv: null, // 选的律师
      printInfo: {
        printTitle: null,
        yuanGao: null,
        beiGao: null,
        diSanren: null,
        ysBeigao: null,
        client: null,
        cause: null,
        fileName: null,
        postDate: null,
        lawyerNames: null,
        checkDate: null,
        title: null,
        charge: null,
        acceptUnit: null,
        caseCode: null,
        cause: null,
        caseType: null,
        sealType: null,
        address: null,
        printTitle: null,
        lsOtherName:null,
      }, //打印数据
      qrcode: null,
      printData: {
        printable: 'casetable',
        // header:'再生资源收货单',
        ignore: ['no-print'],
        type: 'html' // 打印的元素类型
      },
      url: '',
      tableDatalength: 0, //长度
      tcasestatus: 0,
      tcaseresult: 0,
      tbl: false,
      lawFile: '', //打印的法律文件名称
      clientDialog: false,
      clientOptions: [],
      clientOption: null,

      newtype: []
    }
  },

  methods: {
    // 选择dialog关闭
    lsClose() {
      this.ls = null
      this.lv = null
    },
    // 律所改变
    async lvChange() {
      this.lv = null
      if (this.ls == null || this.ls == '') {
        return
      }
      await filesPrintLvSuoApi({
        Id: this.$route.query.guid,
        OName: this.ls
      }).then((res) => {
        if (res.data.status == '0') {
          this.lvShi = res.data.data
        } else if (res.data.status == '1') {
          this.$message.error(res.data.message)
        } else if (
          res.status == '401' ||
          res.status == '402' ||
          res.status == '403'
        ) {
          this.$message.error(res.message)
          window.sessionStorage.removeItem('token')
          window.sessionStorage.removeItem('hasRoles')
          this.$router.push('/login')
        } else {
          this.$message.error('未知错误: casetext:lvChange()')
        }
      })
    },
    async GetFile() {
      // window.scrollTo(0, 1000)
      await new Promise((resolve) => setTimeout(resolve, 1000)) // 延迟1秒
      var node = document.getElementById('dayin') //传入的id名称
      // var width = node.offsetWidth //dom宽
      // var height = node.offsetHeight //dom高
      const name = Math.random().toString(36).substring(2)

      await html2canvas(node, {
        backgroundColor: 'white', //画出来的图片有白色的边框,不要可设置背景为透明色（null）
        useCORS: true, //支持图片跨域
        scale: 1, //设置放大的倍数
        // height: height,
        // width: width,
        onclone(doc) {
          let e = doc.querySelector('#dayin')
          e.style.display = 'block'
        }
      }).then(async (canvas) => {
        // 把生成的base64位图片上传到服务器,生成在线图片地址
        let url = canvas.toDataURL('image/png') // toDataURL: 图片格式转成 base64
        var blob = this.convertBase64ToBlob(url)
        // console.log(blob)
        // 第一步：将dataUrl转换成Blob
        var fd = new window.FormData()
        // var blob = this.dataURItoBlob(url)
        // console.log('打印flag：' + this.$route.query.guid)
        fd.append('flag', this.$route.query.guid)
        fd.append('filetype', '打印')
        fd.append('file', blob)
        fd.append('name', name)
        // 第二步：上传分享图
        axios({
          url: '/api/Filer/PrintUpload',
          method: 'post',
          headers: {
            Content: 'multipart/form-data'
          },
          data: fd
        })
          // .post(`'/api/Filer/PrintUpload?flag=${this.$route.query.guid}'&filetype=${'打印'}`, fd)
          // .post('/api/Filer/PrintUpload', fd)
          .then((res) => {
            // console.log(res)
            if (res.data.status == '0') {
              var id = res.data.data.substring(
                res.data.data.lastIndexOf('=') + 1
              )
              // console.log(id)
              // var code = 'http://localhost:5276/#/print?id=' + id
              var code = 'https://glxt.ntlawyer.cc/#/print?id=' + id
              this.createQrcode(code)
            } else if (
              res.status == '401' ||
              res.status == '402' ||
              res.status == '403'
            ) {
              this.$message.error(res.message)
              window.sessionStorage.removeItem('token')
              window.sessionStorage.removeItem('hasRoles')
              this.$router.push('/login')
            } else {
              this.$message.error('上传错误！: casetext:h2c()')
            }
            this.isLoading = false
          })
          .catch(() => {
            this.$message.error('上传错误！')
            this.isLoading = false
          })
      })
    },
    convertBase64ToBlob(imageEditorBase64) {
      let base64Arr = imageEditorBase64.split(',')
      let imgtype = ''
      let base64String = ''
      if (base64Arr.length > 1) {
        //如果是图片base64，去掉头信息
        base64String = base64Arr[1]
        imgtype = base64Arr[0].substring(
          base64Arr[0].indexOf(':') + 1,
          base64Arr[0].indexOf(';')
        )
      }
      // 将base64解码
      let bytes = atob(base64String)
      //let bytes = base64;
      let bytesCode = new ArrayBuffer(bytes.length)
      // 转换为类型化数组
      let byteArray = new Uint8Array(bytesCode)

      // 将base64转换为ascii码
      for (let i = 0; i < bytes.length; i++) {
        byteArray[i] = bytes.charCodeAt(i)
      }
      // 生成Blob对象（文件对象）
      return new Blob([bytesCode], { type: imgtype })
    },
    // 打印方法
    daYin(params) {
      // this.createQrcode()
      // var html = document.getElementById("das").innerHTML;
      // var casetable = document.getElementById('casetable')
      // casetable.style.display = 'block'
      // setTimeout(() => {
      //   casetable.style.display = 'none'
      // }, 2000)
      // print.js的onPrintDialogClose事件触发失效,在打印事件触发之前，添加派发一个focus聚焦事件，然后点击取消或打印，清除focus事件。
      let focuser = setInterval(
        () => window.dispatchEvent(new Event('focus')),
        500
      )
      printJS({
        printable: params.printable, // 'casetable', // 标签元素id
        type: params.type || 'html',
        header: params.header, // '表单',
        targetStyles: ['*'],
        documentTitle: this.grcode,
        style: '@page {margin:0 10mm};', // 可选-打印时去掉眉页眉尾
        ignoreElements: params.ignore || [], // ['no-print']
        properties: params.properties || null,
        //打印完成或关闭打印的事件
        onPrintDialogClose: () => {
          //取消打印回调
          //清除focus事件
          clearInterval(focuser)
          // casetable.style.display = 'none'
          this.lsDialog = false
        }
      })
    },
    // 确认打印
    async printEnter(params) {
      if (this.ls == null || this.ls == '') {
        return this.$message.error('请选择律所!')
      }
      if (this.lv == null || this.lv == '' || this.lv == []) {
        return this.$message.error('请选择律师!')
      }
      this.isLoading = true
      await filesPrintInfoApi({
        Id: this.$route.query.guid,
        OName: this.ls,
        LawyerName: this.lv,
        LawFile: this.lawFile,
        Stype: this.newtype
      }).then(async (res) => {
        if (res.data.status == '0') {
          this.lsDialog = false
          this.printInfo = res.data.data
          // setTimeout(() => {
          await this.GetFile()
          // }, 2000)
        } else if (res.data.status == '1') {
          this.$message.error(res.data.message)
        } else if (
          res.status == '401' ||
          res.status == '402' ||
          res.status == '403'
        ) {
          this.$message.error(res.message)
          window.sessionStorage.removeItem('token')
          window.sessionStorage.removeItem('hasRoles')
          this.$router.push('/login')
        } else {
          this.$message.error('未知错误: casetext:printEnter()')
        }
        this.isLoading = false
      })
    },
    // 点击导出word
    async exportWord(row) {
      let _this = this
      this.isLoading = true
      this.lawFile = row.name
      if (row.type == 1) {
        await BidDetail({
          Id: _this.Guid,
          SelectType: 2,
          LawFile: row.name
        })
          .then((res) => {
            if (res.data.status == 'success') {
              _this.form = res.data.data[0]
              _this.form.bcz = JSON.parse(res.data.data[0].bcz).client
              _this.form.uploadTime = _this.handleTime(_this.form.uploadTime)
              _this.xl = _this.form.xl
            } else if (
              res.data.status == '401' ||
              res.data.status == '402' ||
              res.data.status == '403'
            ) {
              this.$message.error(res.data.message)
              window.sessionStorage.removeItem('token')
              window.sessionStorage.removeItem('hasRoles')
              this.$router.push('/login')
            } else {
              this.isLoading = false
              return _this.$message.error('导出数据获取失败！')
            }
            this.isLoading = false
          })
          .catch(() => {
            this.isLoading = false
            return _this.$message.error('访问后台失败！')
          })
        // return console.log(this.form)
        //这里要引入处理图片的插件，下载docxtemplater后，引入的就在其中了
        var ImageModule = require('docxtemplater-image-module-free')
        var fs = require('fs')
        const expressions = require('angular-expressions')

        var date = new Date()
        var ll = ''
        var len = _this.form.leadLawyer.length
        // console.log(len)
        _this.form.leadLawyer.forEach((value, index, array) => {
          ll += value
          if (index < len.length - 1) {
            ll += ','
          }
        })
        _this.bclName = ''
        _this.agentOther = ''
        _this.yuanGao = ''
        _this.beiGao = ''
        _this.diSanRen = ''
        _this.form.tableData.forEach((value, index, array) => {
          if (value.isClient) {
            if (_this.bclName) {
              _this.bclName = _this.bclName + '、' + value.name
            } else {
              _this.bclName = value.name
            }
            // _this.bclName += value.name
            // if (index < array.length - 1) {
            //   _this.bclName += ','
            // }
          } else if (
            !value.isClient &&
            (value.attribute == '原告' ||
              value.attribute == '被告' ||
              value.attribute == '第三人')
          ) {
            if (_this.agentOther) {
              _this.agentOther = _this.agentOther + '、' + value.name
            } else {
              _this.agentOther = value.name
            }
            // _this.agentOther += value.name
            // if (index < array.length - 1) {
            //   _this.agentOther += ','
            // }
          }
          if (value.attribute == '原告') {
            if (_this.yuanGao) {
              _this.yuanGao = _this.yuanGao + '、' + value.name
            } else {
              _this.yuanGao = value.name
            }
            // _this.yuanGao += value.name
            // if (index < array.length - 1) {
            //   _this.yuanGao += ','
            // }
          } else if (value.attribute == '被告') {
            if (_this.beiGao) {
              _this.beiGao = _this.beiGao + '、' + value.name
            } else {
              _this.beiGao = value.name
            }
            // _this.beiGao += value.name
            // if (index < array.length - 1) {
            //   _this.beiGao += ','
            // }
          } else if (value.attribute == '第三人') {
            if (_this.diSanRen) {
              _this.diSanRen = _this.diSanRen + '、' + value.name
            } else {
              _this.diSanRen = value.name
            }
            // _this.diSanRen += value.name
            // if (index < array.length - 1) {
            //   _this.diSanRen += ','
            // }
          }
        })
        // 读取并获得模板文件的二进制内容，放在项目中即可（wordTemplate.docx是public文件下的word模版）
        JSZipUtils.getBinaryContent(
          row.name + '.docx',
          function (error, content) {
            if (error) {
              throw error
            }

            expressions.filters.size = function (input, width, height) {
              return {
                data: input,
                size: [width, height]
              }
            }
            function angularParser(tag) {
              const expr = expressions.compile(tag.replace(/’/g, "'"))
              return {
                get(scope) {
                  return expr(scope)
                }
              }
            }
            // 图片处理
            let opts = {}
            opts = { centered: false }
            opts.getImage = (chartId) => {
              return _this.base64DataURLToArrayBuffer(chartId)
            }
            opts.getSize = function (img, tagValue, tagName) {
              // console.log(tagName)
              //自定义指定图像大小，此处可动态调试各别图片的大小
              if (tagName === 'chartImg1') return [249, 200]
              return [300, 200]
            }

            // 创建一个PizZip实例，内容为模板的内容
            let zip = new PizZip(content)
            // 创建并加载docxtemplater实例对象
            let doc = new docxtemplater()
            // 去除未定义值所显示的undefined
            doc.setOptions({
              nullGetter: function () {
                return ''
              }
            })
            doc.attachModule(new ImageModule(opts))
            doc.loadZip(zip)
            var s1 = true
            var s2 = false
            var s3 = false
            var s4 = false
            var s5 = false
            var s6 = false
            var s7 = false
            var s_1 = false
            var s_2 = true
            var s_3 = true
            var s_4 = true
            var s_5 = true
            var s_6 = true
            var s_7 = true
            if (row.stype != undefined) {
              if (row.stype.includes('official_seal')) {
                // 公章
                s1 = true
                s_1 = false

                // console.log('1公章')
              }
              if (row.stype.includes('contract_seal')) {
                // 合同章
                s2 = true
                s_2 = false
                // console.log('2合同章')
              }
              if (row.stype.includes('corporate_seal')) {
                // 法人章

                s3 = true

                s_3 = false
                // console.log('3法人章')
              }
              if (row.stype.includes('official_corporate_seal')) {
                // 公章+法人章

                s4 = true

                s_4 = false
                // console.log('4公章+法人章')
              }
              if (row.stype.includes('contract_corporate_seal')) {
                // 合同章+法人章

                s5 = true

                s_5 = false
                // console.log('5合同章+法人章')
              }
              if (row.stype.includes('legal_letter_seal')) {
                // 律师函专用章

                s6 = true

                s_6 = false
                // console.log('6律师函专用章')
              }
              if (row.stype.includes('law_seal')) {
                // 法律意见书专用章

                s7 = true

                s_7 = false
                //console.log('7法律意见书专用章')
              }
            } else {
              if (_this.form.sealtype == 'official_seal') {
                // 公章
                s1 = true
                s2 = false
                s3 = false
                s4 = false
                s5 = false
                s6 = false
                s7 = false
                s_1 = false
                s_2 = true
                s_3 = true
                s_4 = true
                s_5 = true
                s_6 = true
                s_7 = true
              } else if (_this.form.sealtype == 'contract_seal') {
                // 合同章
                s1 = false
                s2 = true
                s3 = false
                s4 = false
                s5 = false
                s6 = false
                s7 = false
                s_1 = true
                s_2 = false
                s_3 = true
                s_4 = true
                s_5 = true
                s_6 = true
                s_7 = true
              } else if (_this.form.sealtype == 'corporate_seal') {
                // 法人章
                s1 = false
                s2 = false
                s3 = true
                s4 = false
                s5 = false
                s6 = false
                s7 = false
                s_1 = true
                s_2 = true
                s_3 = false
                s_4 = true
                s_5 = true
                s_6 = true
                s_7 = true
              } else if (_this.form.sealtype == 'official_corporate_seal') {
                // 公章+法人章
                s1 = false
                s2 = false
                s3 = false
                s4 = true
                s5 = false
                s6 = false
                s7 = false
                s_1 = true
                s_2 = true
                s_3 = true
                s_4 = false
                s_5 = true
                s_6 = true
                s_7 = true
              } else if (_this.form.sealtype == 'contract_corporate_seal') {
                // 合同章+法人章
                s1 = false
                s2 = false
                s3 = false
                s4 = false
                s5 = true
                s6 = false
                s7 = false
                s_1 = true
                s_2 = true
                s_3 = true
                s_4 = true
                s_5 = false
                s_6 = true
                s_7 = true
              } else if (_this.form.sealtype == 'legal_letter_seal') {
                // 律师函专用章
                s1 = false
                s2 = false
                s3 = false
                s4 = false
                s5 = false
                s6 = true
                s7 = false
                s_1 = true
                s_2 = true
                s_3 = true
                s_4 = true
                s_5 = true
                s_6 = false
                s_7 = true
              } else if (_this.form.sealtype == 'law_seal') {
                // 法律意见书专用章
                s1 = false
                s2 = false
                s3 = false
                s4 = false
                s5 = false
                s6 = false
                s7 = true
                s_1 = true
                s_2 = true
                s_3 = true
                s_4 = true
                s_5 = true
                s_6 = true
                s_7 = false
              }
            }
            // 设置模板变量的值（键是word模版中用的值，值是vue文件data中的变量）
            doc.setData({
              code: _this.form.code,
              title: _this.form.title,
              client: _this.form.bcz,
              acceptUnit: _this.form.acceptUnit,
              cause: _this.form.cause,
              orgName: _this.form.orgName,
              applicantName: _this.form.applicantName,
              uploadTime: _this.form.uploadTime,
              reason: _this.form.reason,
              printYear: date.getFullYear(),
              printMonth: date.getMonth() + 1,
              printDay: date.getDate(),
              leadLawyer: ll,
              bclName: _this.bclName,
              yuanGao: _this.yuanGao,
              beiGao: _this.beiGao,
              diSanRen: _this.diSanRen,
              agentOther: _this.agentOther,
              xl: _this.form.xl == [] || null ? _this.nullxl : _this.form.xl,
              bm: _this.form.bm,
              ec: _this.form.ec,
              seal1: s1,
              seal2: s2,
              seal3: s3,
              seal4: s4,
              seal5: s5,
              seal6: s6,
              seal7: s7,
              seal_1: s_1,
              seal_2: s_2,
              seal_3: s_3,
              seal_4: s_4,
              seal_5: s_5,
              seal_6: s_6,
              seal_7: s_7
            })
            // doc.setData({
            //   code:
            //     _this.form.code == '' || null ? '{案件编号}' : _this.form.code,
            //   title:
            //     _this.form.title == '' || null ? '{案件名}' : _this.form.title,
            //   client:
            //     _this.form.bcz == '' || null ? '{委托人}' : _this.form.bcz,
            //   acceptUnit:
            //     _this.form.acceptUnit == '' || null
            //       ? '{受理机构}'
            //       : _this.form.acceptUnit,
            //   cause:
            //     _this.form.cause == '' || null ? '{案由}' : _this.form.cause,
            //   orgName:
            //     _this.form.orgName == '' || null
            //       ? '{律所简称}'
            //       : _this.form.orgName,
            //   applicantName:
            //     _this.form.applicantName == '' || null
            //       ? '{申请人}'
            //       : _this.form.applicantName,
            //   uploadTime:
            //     _this.form.uploadTime == '' || null
            //       ? '{日期}'
            //       : _this.form.uploadTime,
            //   reason:
            //     _this.form.reason == '' || null ? '{事由}' : _this.form.reason,
            //   printYear: date.getFullYear(),
            //   printMonth: date.getMonth() + 1,
            //   printDay: date.getDate(),
            //   leadLawyer: ll == '' || null ? '{代理律师}' : ll,
            //   bclName:
            //     _this.bclName == '' || null
            //       ? '{代理人/客户名称}'
            //       : _this.bclName,
            //   yuanGao: _this.yuanGao == '' || null ? '{原告}' : _this.yuanGao,
            //   beiGao: _this.beiGao == '' || null ? '{被告}' : _this.beiGao,
            //   diSanRen:
            //     _this.diSanRen == '' || null ? '{第三人}' : _this.diSanRen,
            //   agentOther:
            //     _this.agentOther == '' || null
            //       ? '{非代理人}'
            //       : _this.agentOther,
            //   xl: _this.form.xl == [] || null ? _this.nullxl : _this.form.xl
            // })

            try {
              // 用模板变量的值替换所有模板变量
              doc.render()
            } catch (error) {
              // 抛出异常
              let e = {
                message: error.message,
                name: error.name,
                stack: error.stack,
                properties: error.properties
              }
              // console.log(JSON.stringify({ error: e }))
              this.isLoading = false
              throw error
            }

            // 生成一个代表docxtemplater对象的zip文件（不是一个真实的文件，而是在内存中的表示）
            let out = doc.getZip().generate({
              type: 'blob',
              mimeType:
                'application/vnd.openxmlformats-officedocument.wordprocessingml.document'
            })
            // 将目标文件对象保存为目标类型的文件，并命名

            saveAs(out, row.name + '.docx')
          }
        )
      } else {
        // 判断律所（<代理> 和 <协理> 是否跨所）
        if (row.stype == undefined) {
          this.newtype = null
        } else {
          this.newtype = row.stype
        }
        if (this.lvSuo.length > 1) {
          // 跨所，先选选定律所

          this.qrcode = row.name
          this.isLoading = false
          this.lsDialog = true
        } else {
          // 不跨，查询所需数据
          this.qrcode = row.name
          await filesPrintInfoApi({
            Id: this.Guid,
            OName: null,
            LawyerName: null,
            LawFile: row.name,
            Stype: row.stype
          }).then(async (res) => {
            if (res.data.status == '0') {
              this.printInfo = res.data.data
              this.isLoading = false
              if (this.printInfo.client != null) {
                if (this.printInfo.client.length > 1) {
                  this.clientOptions = this.printInfo.client
                  this.clientDialog = true
                } else if (this.printInfo.client.length == 1) {
                  this.printInfo.client = res.data.data.client?.[0].attribute+res.data.data.client?.[0].pcname
                  await this.GetFile()
                }else{
                  await this.GetFile()
                }
              } else {
                await this.GetFile()
              }
            } else if (res.data.status == '1') {
              this.$message.error(res.data.message)
            } else if (
              res.status == '401' ||
              res.status == '402' ||
              res.status == '403'
            ) {
              this.$message.error(res.message)
              window.sessionStorage.removeItem('token')
              window.sessionStorage.removeItem('hasRoles')
              this.$router.push('/login')
            } else {
              this.$message.error('未知错误: casetext:printEnter()')
            }
          })
        }
      }
    },

    // 选择代理人打印
    async clientPrint(cp) {
      var newclientOptions = this.clientOptions.filter((item) => {
        return cp.includes(item.pvalue)
      })
      const result = newclientOptions.reduce((acc, cur) => {
      if (!acc[cur.attribute]) {
        acc[cur.attribute] = { attribute: cur.attribute, pcnames: [cur.pcname] };
      } else {
        acc[cur.attribute].pcnames.push(cur.pcname);
      }
      return acc;
    }, {});

const output = Object.values(result).map(item => `${item.attribute}${item.pcnames.join('、')}`).join(',');

      this.printInfo.client = output
      this.printInfo.agent = output
      this.clientDialog = false
      await this.GetFile()
    },
    getvalue() {
      //传值给父组件，
      this.$emit('value', this.next)
    },
    del(id) {
      //删除
      this.$confirm('此操作将删除该文件，不可恢复, 是否继续?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      })
        .then(() => {
          FileDel({ Id: id }).then((res) => {
            if (res.data.status == 'success') {
              this.$message({
                type: 'success',
                message: '删除成功!'
              })
              this.search()
            } else if (
              res.data.status == '401' ||
              res.data.status == '402' ||
              res.data.status == '403'
            ) {
              this.$message.error(res.data.message)
              window.sessionStorage.removeItem('token')
              window.sessionStorage.removeItem('hasRoles')
              this.$router.push('/login')
            } else {
              this.$message({
                type: 'error',
                message: res.data.message
              })
            }
          })
        })
        .catch(() => {
          this.$message({
            type: 'info',
            message: '已取消删除'
          })
        })
    },
    async down(item) {
      //下载
      this.isLoading = true
      const res = await requestDownLoadFile({
        Id: item.id
      })
      if (res.data.type && res.data.type.includes('application/json')) {
        this.handlerResponseError(res.data)
      } else {
        this.getDownLoadFile(res.data, res['headers']['content-type'], item)
      }
    },
    handlerResponseError(data) {
      const _this = this
      const fileReader = new FileReader()
      fileReader.onload = function () {
        try {
          const jsonData = JSON.parse(fileReader.result) // 说明是普通对象数据，后台转换失败
          if (
            jsonData.status == '401' ||
            jsonData.status == '402' ||
            jsonData.status == '403'
          ) {
            _this.$message.error(jsonData.message)
            window.sessionStorage.removeItem('token')
            window.sessionStorage.removeItem('hasRoles')
            _this.$router.push('/login')
          }
          // dosomething……
        } catch (err) {
          // 解析成对象失败，说明是正常的文件流
          console.log('success...')
        }
      }
      this.isLoading = false
      fileReader.readAsText(data)
    },
    // 获取文件后缀
    getFileType(name) {
      if (name) {
        if (name.lastIndexOf('.') > -1) {
          return name.slice(name.lastIndexOf('.') + 1).toLowerCase()
        } else {
          return false
        }
      }
    },
    getDownLoadFile(blobFile, contenttype, row) {
      let downloadBolb = null
      let fileType = this.getFileType(row.name)
      // console.log(fileType)
      // 后台接口方法url：接口地址，data给后台传的参数
      let type = ''
      if (fileType) {
        type = fileTypeMap[fileType]
        downloadBolb = new Blob([blobFile], {
          type: type
        })
        // 下载文件
        this.downloadFile(downloadBolb, row.name)
        this.isLoading = false
        return downloadBolb
      }
    },
    downloadFile(blob, fileName) {
      let eleLink = document.createElement('a')
      eleLink.download = fileName
      eleLink.style.display = 'none'
      // 字符内容转变成blob地址
      eleLink.href = this.getObjectURL(blob)
      // 自动触发点击
      document.body.appendChild(eleLink)
      eleLink.click()
      // 然后移除
      document.body.removeChild(eleLink)
    },

    getObjectURL(file) {
      let url = null
      if (window.createObjectURL !== undefined) {
        // basic
        url = window.createObjectURL(file)
      } else if (window.webkitURL !== undefined) {
        // webkit or chrome
        try {
          url = window.URL.createObjectURL(file)
        } catch (error) {
          console.log(error)
        }
      } else if (window.URL !== undefined) {
        // mozilla(firefox)
        try {
          url = window.URL.createObjectURL(file)
        } catch (error) {
          console.log(error)
        }
      }
      return url
    },
    async typeSelect(index) {
      // 类型
      this.currentIndex = index
      if (index == 0) {
        this.filetype = '案件附件'
        // this.name = "";
        this.tableData = []
        this.search()
      } else if (index == 1) {
        await this.GetNewSealType()
        // 法律文件查询
        this.filetype = '法律文件'
        // console.log(this.CaseStatus)
        if (this.CaseStatus == 0) {
          this.tableData = this.falvTable
        } else {
          this.tableData = []
        }

        // this.tableData = []
        // this.name = "";
        // this.search()
        await filesPrintLvSuoApi({ Id: this.$route.query.guid }).then((res) => {
          if (res.data.status == '0') {
            this.lvSuo = res.data.data
          } else if (res.data.status == '1') {
            this.$message.error(res.data.message)
          } else if (
            res.status == '401' ||
            res.status == '402' ||
            res.status == '403'
          ) {
            this.$message.error(res.message)
            window.sessionStorage.removeItem('token')
            window.sessionStorage.removeItem('hasRoles')
            this.$router.push('/login')
          } else {
            this.$message.error('未知错误: casetext:typeSelect()')
          }
        })
      }
    },
    search() {
      this.isLoading = true
      if (this.casetype == '破产') {
        BankruptFile({
          Id: this.Guid,
          Filetype: this.filetype,
          name: this.name
        }).then((res) => {
          if (res.data.status == 'success') {
            
             if(res.data.data.length){
              this.tableData = res.data.data
              this.tableDatalength = this.tableData.length
              if (this.tableData.length > 0) {
                this.tbl = this.tableData[0].bl
                this.tcasestatus = this.tableData[0].casestatus
                this.caseresult = this.tableData[0].caseresult
                if (
                  // this.tableData[0].sealstatus == 0 &&
                  // this.tableData[0].sealResult == 0 &&
                  this.tableData[0].caseresult == 0 &&
                  (this.tableData[0].casestatus == 0 ||
                    this.tableData[0].casestatus == 2 ||
                    this.tableData[0].casestatus == 3)
                ) {
                  this.CaseStatus = 0
                } else {
                  this.CaseStatus = 1
                }
              }
             }else{
                this.tbl = res.data.data.bl
                this.tcasestatus = res.data.data.casestatus
                this.caseresult = res.data.data.caseresult
                if (
                  res.data.data.caseresult == 0 &&
                  (res.data.data.casestatus == 0 ||
                  res.data.data.casestatus == 2 ||
                  res.data.data.casestatus == 3)
                ) {
                  this.CaseStatus = 0
                } else {
                  this.CaseStatus = 1
                }
              }
          } else if (
            res.data.status == '401' ||
            res.data.status == '402' ||
            res.data.status == '403'
          ) {
            this.$message.error(res.data.message)
            window.sessionStorage.removeItem('token')
            window.sessionStorage.removeItem('hasRoles')
            this.$router.push('/login')
          } else {
            this.$message.error(res.data.message)
          }
          this.isLoading = false
        })
      } else {
        BidFile({
          Id: this.Guid,
          Filetype: this.filetype,
          name: this.name
        }).then((res) => {
          if (res.data.status == 'success') {
            this.tableData = res.data.data
            this.tableDatalength = this.tableData.length
            if (this.tableData.length > 0) {
              this.tbl = this.tableData[0].bl
              this.tcasestatus = this.tableData[0].casestatus
              this.caseresult = this.tableData[0].caseresult

              if (
                // this.tableData[0].sealstatus == 0 &&
                // this.tableData[0].sealResult == 0 &&
                this.tableData[0].caseresult == 0 &&
                (this.tableData[0].casestatus == 0 ||
                  this.tableData[0].casestatus == 2 ||
                  this.tableData[0].casestatus == 3)
              ) {
                this.CaseStatus = 0
              } else {
                this.CaseStatus = 1
              }
            }
          } else if (
            res.data.status == '401' ||
            res.data.status == '402' ||
            res.data.status == '403'
          ) {
            this.$message.error(res.data.message)
            window.sessionStorage.removeItem('token')
            window.sessionStorage.removeItem('hasRoles')
            this.$router.push('/login')
          } else {
            this.$message.error(res.data.message)
          }
          this.isLoading = false
        })
      }
    },
    searchLawFile() {
      this.tableData = this.falvTable
      if (this.name != '') {
        this.tableData = this.tableData.filter((item) => {
          return item.name.includes(this.name)
        })
      }
    },
    handleRemove(file, fileList) {
      //删除附件
    },
    handlePreview(file) {
      // console.log(file)
    },
    onChange(file) {
      if (file.status == 'fail') {
        return this.$message.error(file.name + '上传失败')
      }
    },

    beforeUpload(file, filelist) {
      var type = file.name
        .substring(file.name.lastIndexOf('.') + 1)
        .toLowerCase()
      const isImg =
        '.jpg,.jpeg,.png,.doc,.docx,.xls,.xlsx,pdf,.wps,.WPS'.indexOf(type) >= 0
      const isMaxSize = file.size / 1024 / 1024 < 50
      if (!isImg) {
        this.$message.error(
          '只能上传jpg,jpeg,png,doc,docx,xls,xlsx,pdf格式的文件'
        )
      }
      if (!isMaxSize) {
        this.$message.error('上传大小不能超过50MB！')
      }
      return isImg && isMaxSize
    },
    uploadSuccess(res, file, fileList) {
      if (res.status == '0') {
        this.$message.success('上传成功')
        this.search()
        this.$refs.upload.clearFiles() //去掉文件列表
      } else if (
        res.status == '401' ||
        res.status == '402' ||
        res.status == '403'
      ) {
        this.$message.error(res.message)
        window.sessionStorage.removeItem('token')
        window.sessionStorage.removeItem('hasRoles')
        this.$router.push('/login')
      } else {
        this.$message.error('上传失败')
      }
    },
    confirm() {
      //确定文件类型，上传文件
      this.fileDialog = false

      this.$refs['upload'].$refs['upload-inner'].handleClick()
    },
    typechange() {
      //文件类型
      if (this.casetype == '破产') {
        this.fileType = [
          { value: '招标', label: '投标方案' },
          { value: '法院的受理裁定书', label: '法院的受理裁定书' },
          { value: '管理人决定书', label: '管理人决定书' },
          { value: '附件', label: '普通文件' },
          { value: '发票', label: '发票', disabled: true },
          { value: '免费', label: '免费凭证' }
        ]
      } else if (this.casetype == '破产投标') {
        this.fileType = [
          { value: '招标', label: '招标文件' },
          { value: '附件', label: '普通文件' },
          { value: '免费', label: '免费凭证' }
        ]
      }
    },
    // 时间格式
    handleTime(time) {
      // yyyy-MM-dd HH:MM:SS
      var t = new Date(time).toJSON()
      return new Date(+new Date(t) + 8 * 3600 * 1000)
        .toISOString()
        .replace(/T/g, ' ')
        .replace(/\.[\d]{3}Z/, '')
    },
    // 按钮文字
    daochuOrDayin(row) {
      if (row.type == 2) {
        return '打印'
      } else {
        return '导出'
      }
    },
    //生成二维码方法
    createQrcode(code) {
      let container = document.getElementById('ercode')
      if (container.innerHTML) {
        container.innerHTML = ''
      }
      var qrcode = new QRCode(container, {
        text: code, //这里就是二维码扫描后展示的内容了
        width: 100,
        height: 100,
        colorDark: 'black',
        colorLight: 'white',
        correctLevel: QRCode.CorrectLevel.L //二维码的纠错等级，等级越高，二维码呈现越复杂，同时被遮挡的多，也能扫出来
      })
      qrcode.makeCode(code)
      this.daYin(this.printData)
      // const result = new AraleQRCode({
      //       render: "svg",      // 定义生成的类型 'svg' or 'table dom’
      //       text: this.imhurl, // 二维码的链接
      //       size: 150,      //二维码大小
      // });

      // // console.log(this.$refs.das.innerHTML)
      // // 将svg xml文档转换成字符串
      // const svgXml = new XMLSerializer().serializeToString(result);

      // // 将svg字符串转成base64格式，通过 window.btoa方法创建一个 base-64 编码的字符串，进行二次编码解码(encodeURIComponent 字符串进行编码和解码，unescape 进行解码)。
      // const src =
      //       "data:image/svg+xml;base64," +
      //       window.btoa(unescape(encodeURIComponent(svgXml)));

      // // 本地存储图片
      // localStorage.setItem("image", src);
      // this.getImg();
    },
    // 案件类型
    caseTypeSelect() {
      this.falvTable = [
        {
          name: '案件审批单', // 模板名
          type: 2 // 类型(1:导出，2:打印)
        }
      ]
    },
    // 获取文档
    async GetNewSealType() {
      this.falvTable = []
      await getNewSealType({ Id: this.$route.query.guid }).then((res) => {
        // console.log('GetNewSealType', res.data.data)
        if (res.data.status == '0') {
          if (res.data.data != null) {
            var st = JSON.parse(res.data.data)
            st.forEach((v) => {
              if (v.name != null) {
                this.falvTable.push(v)
              }
            })
          } else {
            this.caseTypeSelect()
          }
          // const cC = new Set(oldst.map((m) => m))
          // this.tableData.map((city) => {
          //   // 不包含
          //   if (!cC.has(city.name)) {
          //     this.tableData.splice(this.tableData.indexOf(city), 1)
          //   }
          // })
          // console.log(this.falvTable)
          // this.tablelData = this.tableData.filter(city=>cC.has(city.name))
        } else if (res.data.status == '1') {
          this.$message.error(res.data.message)
        } else if (
          res.status == '401' ||
          res.status == '402' ||
          res.status == '403'
        ) {
          this.$message.error(res.message)
          window.sessionStorage.removeItem('token')
          window.sessionStorage.removeItem('hasRoles')
          this.$router.push('/login')
        } else {
          this.$message.error('未知错误: casetext:lvChange()')
        }
      })
    }
  },
  created() {
    this.Guid = this.$route.query.guid
    this.casetype = this.$route.query.type
    this.typechange()
    this.search()
    this.getvalue()
    var pagestype = this.$route.query.mystatus
    if (pagestype == 1) {
      if (this.$store.state.rolesname.includes('myDetail_update')) {
        this.fileupdatequanxian = true
      }
      if (this.$store.state.rolesname.includes('myDetail_down')) {
        this.downqx = true
      }
    } else if (pagestype == 2) {
      if (this.$store.state.rolesname.includes('allDetail_update')) {
        this.fileupdatequanxian = true
      }
      if (this.$store.state.rolesname.includes('allDetail_down')) {
        this.downqx = true
      }
    } else if (type == 5) {
      if (this.$store.state.rolesname.includes('filedDetail_down')) {
        this.downqx = true
      }
    }else if (type == 6) {
      if (this.$store.state.rolesname.includes('allbankDetail_update')) {
        this.fileupdatequanxian = true
      }
      if (this.$store.state.rolesname.includes('allbankDetail_down')) {
        this.downqx = true
      }
    }
  },
  mounted() {
    if (window.name == '') {
      window.name = new Date()
    }
    this.opentime = this.handleTime(window.name)
    // console.log(this.opentime)
  },
  beforeDestroy() {
    window.name = ''
  },
  computed: {}
}
</script>

<style lang="less" scoped>
#file {
  width: 100%;
  margin: auto;
}
// 查询
.search {
  width: 40%;
  margin-top: 24px;
}
/deep/ .el-input--prefix .el-input__inner {
  border-radius: 12px;
  border: none;
  background: #fafafa;
}
/deep/ .el-input__icon {
  color: #111827;
}

#file .divider {
  width: calc(100% - 50px);
  float: right;
  border-top: 1px solid rgba(238, 239, 242, 1);
  margin-top: 24px;
}

//左
.left {
  width: calc(100% - 450px);
  float: left;
  border-right: 1px solid rgba(238, 239, 242, 1);
  margin-top: -24px;
  margin-left: 50px;
}
.mian {
  margin-top: 24px;
  width: 100%;
  border-top: 1px solid rgba(238, 239, 242, 1);
}

.type {
  width: 24%;
  height: 100%;
  // border-right: 1px solid rgba(238, 239, 242, 1);
  margin-top: 16px;
  float: left;
}
.active {
  background-color: #d2e3fd;
  border-radius: 8px;
}
.title {
  cursor: pointer;
  padding: 18px;
  text-align: center;
  height: 50%;
  font-size: 15px;
  color: #718096;
}
img {
  vertical-align: middle;
  vertical-align: -0.15em;
}
// 表格
.table {
  width: 75%;
  float: right;
  min-height: 60vh;
  border-left: 1px solid rgba(238, 239, 242, 1);
}
// 右 上传
.right {
  width: 390px;
  float: right;
}

// 打印
.dayin {
  width: 50%;
  padding: 0;
  margin: 0;
  box-sizing: border-box;
  -moz-box-sizing: border-box;
  -webkit-box-sizing: border-box;
  font-family: '宋体';
  display: none;
  // display: flex;

  .chenghu {
    text-decoration: underline;
    display: inline-block;
    min-width: 300px;
  }
  #casetable {
    width: 557px;
    margin: 0 auto;
    font-family: '宋体';
    line-height: 50px;
    font-size: 27.9px;
  }

  #casetable .center_font {
    text-align: center;
  }

  #casetable .case_title {
    font-size: 36px;
    font-weight: bold;
  }

  .case_code {
    font-size: 27.9px;
  }

  .input_con {
    border-bottom: 1px solid #333;
    width: 180px;
    display: inline-block;
  }

  .input_shortcon {
    border-bottom: 1px solid #333;
    width: 10%;
    display: inline-block;
  }

  .case_span_border {
    border-bottom: 1px solid #333;
  }

  .case_row {
    height: 40px;
  }

  .text-right {
    text-align: right;
  }

  .text_space {
    text-indent: 2em;
  }

  .text_center {
    text-align: center;
  }

  .qrcode {
    /*二维码*/
    margin-left: 14px;
  }

  .case_tb {
    width: 100%;
    height: 700px; /*overflow:hidden;*/
  }

  table tr .td_l {
    width: 30%;
    font-size: 17px;
    font-weight: bold;
    text-align: center;
    line-height: 22px;
  }

  table tr .td_r {
    width: 70%;
    font-size: 15px !important;
    text-align: center;
    line-height: 22px;
  }

  .td_gy {
    height: 80px;
  }

  .td_hhr {
    height: 70px;
  }

  table tr td label {
    float: left;
    line-height: 30px;
    width: 32%;
  }

  table tr td label input {
    vertical-align: middle;
    height: 18px;
    width: 19px;
  }

  table tr td label span {
    vertical-align: middle;
    color: #333;
    font-weight: 100;
  }

  .td_rs {
    padding: 0 20px;
  }

  table tr td p {
    width: 100%;
    line-height: 22px;
    font-size: 14px;
    padding: 0 2%;
    margin-bottom: 5px;
    color: #666;
    float: left;
    text-align: left;
  }

  table tr td p .case_span_border {
    min-width: 50%;
  }

  #Print_btn {
    float: right;
    margin-bottom: 25px;
    line-height: 25px;
    margin-left: 15px;
  }

  #FenSuoChange {
    float: right;
    margin-bottom: 25px;
    height: 31px;
  }

  .AdmissibleInstitution_span {
    display: inline-block;
    min-width: 45%;
    line-height: 20px;
    margin-left: 40px;
  }

  .td_zhu {
    font-size:9px;
  }

  .td_p_date {
    width: 40%;
    float: right;
    font-size: 30px;
    text-align: right;
  }

  table tr .td_gaiyao {
    text-align: left;
    text-indent: 40px;
  }

  table tr .td_time {
    text-align: right;
  }

  .minwidth {
    min-width: 0;
  }

  .han_margintop {
    margin-top: 30px;
  }
}

.lsdialog {
  text-align: center;
  display: flex;
  padding-top: 1%;
  padding-left: 18%;
}
.printenter {
  text-align: center;
  padding-top: 10%;
}
</style>
      